var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeleteIcon = function SvgDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "delete-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-2-2h17v17H-2z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#delete-icon_svg__a)",
    "data-name": "Scroll Group 34",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    },
    transform: "translate(2 2)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ff3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    "data-name": "Group 2622"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.938 4.45s-.416 5.173-.657 7.352a1.716 1.716 0 0 1-1.807 1.67c-2 .036-4 .038-6 0a1.7 1.7 0 0 1-1.754-1.661c-.243-2.2-.657-7.357-.657-7.357",
    "data-name": "Path 18610"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 2.18H0",
    "data-name": "Path 18611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.492 2.179a1.263 1.263 0 0 1-1.237-1.017L9.069.228a.98.98 0 0 0-.947-.729H4.879a.98.98 0 0 0-.947.729l-.186.934A1.263 1.263 0 0 1 2.51 2.179",
    "data-name": "Path 18612"
  })))));
};
export default SvgDeleteIcon;